import { getValueFromToken } from './getValueFromToken';

export const isPilotCustomer = () => {
  return getValueFromToken('isPilotCustomer');
};
